module.exports = __webpack_public_path__ + "static/img/tp.9dfc51a3.png";